/* tslint:disable: no-object-literal-type-assertion */
import * as React from 'react'; // We will never use default, here only to fix TypeScript warning

var MentionsContext = /*#__PURE__*/React.createContext(null);
export var MentionsContextProvider = MentionsContext.Provider;
export var MentionsContextConsumer = MentionsContext.Consumer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-mentions/es/MentionsContext.js
// module id = 474
// module chunks = 0